import { PATH_DASHBOARD } from "routes/paths";
import { ICONS } from "./utils";

export const DashMenus = [
  
];
